import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { EndWidgetChatResponse } from 'server';
import { appFetch } from './appFetch';
import { widgetKeys } from './keys';

export const useEndChat = (chatId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (): Promise<EndWidgetChatResponse> => {
      const response = await appFetch<EndWidgetChatResponse>(`/app/public/widget/chats/${chatId}/end`, {
        method: 'POST'
      });
      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: widgetKeys.chat(chatId) });
    }
  });
};
